/** Plain-English tab intros for accessibility + onboarding (matches design system UX). */
export const PRIMARY_TABS = [
  {
    id: "overview",
    label: "Overview",
    short: "Home",
    path: "/",
    icon: "⌂",
    title: "Overview",
    description: "Jump into live environmental APIs and the regulations matrix.",
    tourId: "nav-overview",
  },
  {
    id: "data",
    label: "Data",
    short: "Data",
    path: "/data/sites",
    icon: "◧",
    title: "Environmental data (live)",
    description: "Live SST and biodiversity context from public APIs—maps, species, plume screening, migration, and documents.",
    tourId: "nav-data",
  },
  {
    id: "regulations",
    label: "Regulations",
    short: "Regs",
    path: "/regulations",
    icon: "⚖",
    title: "Regulations",
    description: "Explore thresholds from EPA, states, provinces, and CCME with citations, gaps, and a searchable matrix—plus live SST for screening.",
    tourId: "nav-regulations",
  },
  {
    id: "sources",
    label: "Sources",
    short: "Sources",
    path: "/sources",
    icon: "✓",
    title: "Data sources & verification",
    description: "Official portals and APIs behind the numbers—open each link to fact-check against primary sources.",
    tourId: "nav-sources",
  },
];

export const DATA_SUBTABS = [
  { id: "sites", label: "Sites", icon: "🗺", title: "Site explorer", description: "Pick a West Coast candidate location, see screening SST bands, risks, and live geodata for that point." },
  { id: "species", label: "Species", icon: "🐟", title: "Species thresholds", description: "Thermal tolerance bands and literature-backed notes for focal species and habitats." },
  { id: "plume", label: "Plume", icon: "🌡", title: "Plume simulator", description: "Screening-grade 2D thermal field—tune power, ΔT, current, and depth; not a permit model." },
  { id: "migration", label: "Migration", icon: "📊", title: "Migration & habitat", description: "Timing grid and habitat-loss references used in regional planning discussions." },
  { id: "documents", label: "Library", icon: "📄", title: "Document library", description: "RAG — document search will be added in a future update. Upload PDFs and URLs for chunking and search—requires the FastAPI backend and Elasticsearch stack." },
];